import { Component, Inject, InjectionToken, ViewChild } from '@angular/core';
import { EmailService, IDraftEmailManagerFactory, IDraftEmailManagerItem, IEmailHandler, IDraftEmail, EncounterDraftEmail, 
        ReceivedEmail, ReferralDraftEmail, SentEmailListComponent, ReceivedEmailListComponent, EmailComposerComponent,
        BlockUI} from '@harlowe/core';
import { EncounterService } from '../../../services/encounter.service';
import { Store } from '@ngxs/store';
import { lastValueFrom } from 'rxjs';
import { DockModule } from 'primeng/dock';
import { TabViewModule } from 'primeng/tabview';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { PanelModule } from 'primeng/panel';
import { AsyncPipe, CommonModule, DatePipe, NgIf } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { MenuModule } from 'primeng/menu';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { EncounterState } from '../../../state/encounters/encounter-state';
import { TealCompEncounter } from '../../../models/encounter';
import { EncounterEmailHandler } from '../../encounter/encounter-editor/encounter-email-handler';
import { ReferralService } from '../../../services/referral.service';
import { ClaimService } from '../../../services/claim.service';
import { instanceToInstance } from 'class-transformer';
import { EmailState } from '../../../state/encounter-email/email-state';
import { EncounterDraftEmailManagerItem } from './encounter-draft-email-manager';
import { BadgeModule } from 'primeng/badge';

export const DRAFT_EMAIL_ITEM_FACTORY = new InjectionToken<string>('Draft_Email_Item_Factory');

@Component({
  selector: 'app-email-sidebar',
  standalone: true,
  imports: [DockModule, SentEmailListComponent, NgIf, ReceivedEmailListComponent, EmailComposerComponent, 
            CommonModule, FormsModule, EmailSidebarComponent, AsyncPipe, TabViewModule, TableModule, DatePipe,
            MenuModule, TagModule, PanelModule, ButtonModule, OverlayPanelModule, CheckboxModule, DropdownModule,
            BadgeModule],
  templateUrl: './email-sidebar.component.html',
  styleUrl: './email-sidebar.component.scss'
})

export class EmailSidebarComponent {

  encounterDraftEmails$ = this._store.select(EmailState.encounterDraftEmails)
  referralDraftEmails$ = this._store.select(EmailState.referralDraftEmails)

  receivedEmails$ = this._store.select(EmailState.receivedEmails);
  unreadEmails$ = this._store.select(EmailState.unreadReceivedEmails);
  encounters$ = this._store.select(EncounterState.openEncounters)

  encounter: TealCompEncounter | undefined; 

  encounterDraftEmailItems: IDraftEmailManagerItem[] = [];
  referralDraftEmailItems: IDraftEmailManagerItem[] = [];

  receivedEmails: ReceivedEmail[] = []; 
  unreadEmails: ReceivedEmail[] = [];

  selectedEmails: ReceivedEmail[] = [];

  draftEmail: IDraftEmail = {} as IDraftEmail;
  emailHandler: IEmailHandler | undefined = undefined;

  newEmailDialogVisible: boolean = false;
  selectedDraft?: IDraftEmail; 
  @ViewChild('draftEditor') draftEditor?: OverlayPanel;


  constructor
  (
    public _store: Store,
    private emailService: EmailService,
    private encounterService: EncounterService,
    private referralService: ReferralService,
    private claimService: ClaimService,
    @Inject(DRAFT_EMAIL_ITEM_FACTORY) private _draftEmailItemFactory: IDraftEmailManagerFactory,
    // private _encounters: EncounterService,
  )
  {
    this.encounterDraftEmails$.subscribe
    (
      drafts =>
      {
        this.encounterDraftEmailItems = [];

        for (var draft of drafts)
        {
          this.encounterDraftEmailItems.push(this._draftEmailItemFactory.createDraftEmailManagerItem(draft));
        }
      }
    )

    this.referralDraftEmails$.subscribe
    (
      drafts =>
      {
        this.referralDraftEmailItems = [];

        for (var draft of drafts)
        {
          this.referralDraftEmailItems.push(this._draftEmailItemFactory.createDraftEmailManagerItem(draft));
        }
      }
    )

    this.receivedEmails$.subscribe
    (
      e =>
      {
        this.receivedEmails = e;
      }
    )

    this.unreadEmails$.subscribe
    (
      e =>
      {
        this.unreadEmails = e;
      }
    )

  }

  passDraft(draft: IDraftEmail)
  {
    var clonedDraft = instanceToInstance(draft);

    clonedDraft.recipients = [...(clonedDraft.recipients || [])];
    clonedDraft.ccs = [...(clonedDraft.ccs || [])];
    clonedDraft.bccs = [...(clonedDraft.bccs || [])];
    clonedDraft.attachmentIds = [...(clonedDraft.attachmentIds || [])];

    return clonedDraft
    
  }

  async deleteButtonPressed(event:MouseEvent, emailId: number, draftType: string)
  {
    await this.emailService.deleteDraftEmail(emailId);
  }



  async sendDraft(draftEmail: IDraftEmail)
  {
    this._store.dispatch(new BlockUI.BlockUI());
    var draft: any = draftEmail;
    if (draft.encounterId != undefined)
      await this.encounterService.sendEncounterDraftEmail(draftEmail as EncounterDraftEmail).then(email => this.newEmailDialogVisible = false);
    if (draft.referralId != undefined)
      await this.referralService.sendReferralDraftEmail(draftEmail as ReferralDraftEmail).then(email => this.newEmailDialogVisible = false);
    this._store.dispatch(new BlockUI.UnBlockUI());
  }
 
  get sortedEmails() : ReceivedEmail[]
  {
    var sortedVals = this.receivedEmails.toSorted((a,b) => b.dateReceived.valueOf() - a.dateReceived.valueOf());
    return sortedVals ?? [];
  }

  get sortedUnreadEmails() : ReceivedEmail[]
  {
    var sortedVals = this.unreadEmails.toSorted((a,b) => b.dateReceived.valueOf() - a.dateReceived.valueOf());
    return sortedVals ?? [];
  }

  async assignEncounterButtonPressed(event: MouseEvent)
  {
    if (this.encounter && this.selectedEmails.length > 0) 
    {
      var emailIds = this.selectedEmails.map(e => e.id);
      await this.encounterService.assignEmailsToEncounter(this.encounter.id, this.selectedEmails);
      this.receivedEmails = this.receivedEmails.filter((e) => !emailIds.includes(e.id));
    }
  }

  async emailViewed(event: any, emailId: number, emailRead: boolean)
  {
    if (!emailRead)
      await this.emailService.readReceivedEmail(emailId);
  }

  async createHandler(email: EncounterDraftEmailManagerItem)
  {
    var draft: EncounterDraftEmail | ReferralDraftEmail = email.getDraftEmail();

    var draftType: number = -1
    if (draft instanceof EncounterDraftEmail)
    {
      this.encounter = await lastValueFrom(this.encounterService.getEncounter(draft.encounterId));
      draftType = 0;
    }
    else if (draft instanceof ReferralDraftEmail)
    {
      var referral = await this.referralService.getReferral(draft.referralId)
      this.encounter = await lastValueFrom(this.encounterService.getEncounter(referral.encounterId))
      draftType = 1;
    }

    var encounterEmailHandler = await new EncounterEmailHandler(this.encounter as TealCompEncounter, this.emailService, this.encounterService, this.referralService, this.claimService, this._store).create(draftType);
    email.setEmailHandler(encounterEmailHandler);
    this.emailHandler = encounterEmailHandler;
  }

  async openEditor(email: EncounterDraftEmailManagerItem, event: MouseEvent)
  {
    this._store.dispatch(new BlockUI.BlockUI());
    
    if (email.getHandler() == undefined)
      await this.createHandler(email);

    this.selectedDraft = instanceToInstance(email.getDraftEmail());

    this._store.dispatch(new BlockUI.UnBlockUI());
    this.draftEditor?.toggle(event);
  }

  async goToRelatedEncounter(email: EncounterDraftEmailManagerItem)
  {
    var handler: EncounterEmailHandler | undefined = email.getHandler();
    if (handler == undefined)
      await this.createHandler(email);
    email.goToRelatedItem();
  }

  editorClosed()
  {
    this.selectedDraft = undefined;
    this.encounter = undefined;
  }

  allowAssignment()
  {
    return this.encounter && this.selectedEmails.length > 0;
  }
   
}
